import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import onClickOutside from 'react-onclickoutside';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  HashLink as Link,
  NavHashLink as NavLink,
} from 'react-router-hash-link';

import { APIHandler, DataHandler, Diploma, StorageHandler } from 'C4';
import { storageKeys } from 'settings';

class Dropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appId: -1,
      user: '',
      profileImage: '',
      userStatus: 'startTraining',
      appName: '',
      diploma: false,
      clientName: ''
    };

    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    this.openSettings();
    this.getAppInfo();
    this.getProgress();
  }

  handleClickOutside() {
    this.props.handleClickOutside();
  }

  getAppInfo() {
    StorageHandler.load(storageKeys.appInfo).then((res) => {
      if (res) {
        this.setState({ appName: res.appName, clientName: res.clientName });
      }
    });
  }

  async getProgress() {
    const { email } = this.props;
    if (email) {
      const appId = await DataHandler.matchAppId();
      const app = await APIHandler.getUserProgress(appId, email);
      if (app && app.data && app.data[0].chapters) {
        const { chapter } = app.data[0].chapters[0];

        let lastPage = 0;
        let userStatus = 'startTraining';
        if (app.data[0].chapters[0].progress >= (app.data[0].chapters[0].total_pages - 1)) {
          userStatus = 'graduated';
        }

        this.setState({
           userStatus
        });
      }
    }
  }

  async openSettings() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    const { questionHeader } = appInfo;
    this.setState({ profileImage: questionHeader });

    const { appId, user } = this.state;
    if (appId === -1 || user === '') {
      DataHandler.matchAppId().then((id) => {
        StorageHandler.load(storageKeys.user).then((userKey) => {
          const { email } = userKey;
          this.setState({
            appId: id,
            user: email,
            frame: `https://accounts.travpromobile.com/profile/?header=false&email=${email}&app_id=${id}`,
          });
        });
      });
    } else {
      this.setState({
        frame: `https://accounts.travpromobile.com/profile/?header=false&email=${user}&app_id=${appId}`,
      });
    }
  }

  render() {
    const {
      email,
      firstName,
      lastName,
      unreadMessageCount,
      trainingComplete,
    } = this.props;
    const { frame, profileImage, appName, clientName, diploma, userStatus, appId } = this.state;
    return (
      <div className="dropDown">
        <div
          className="dropDown__Header"
          style={{ backgroundImage: `url(${profileImage.replace('front.travpromobile.com', 'imgtravpromobile.imgix.net')}?quality=70&fm=jpg)` }}
        >
          <Link to="/" className="dropDown__Header-profile">
            <FontAwesomeIcon icon={['fas', 'user']} />
            {`${firstName} ${lastName}`}
            <br />
            <span>{email}</span>
          </Link>
        </div>
        <div className="dropDown__Nav">
          <ul>
            <li>
              <button
                data-trigger="settings"
                data-fancybox-rel="settings"
                className="settings"
                href={frame}
              >
                {i18n.translate('nav.accountSettings')}
              </button>
            </li>
            {userStatus === 'graduated' &&
              <li
                onClick={() => this.setState({ diploma: true })}
              >
                <button
                  className="settings noPointer"
                >
                  <FontAwesomeIcon icon={['fas', 'trophy']} />
                  View Badge
                </button>
              </li>
            }
          </ul>
        </div>
        <div className="dropDown__Footer">
          <hr />
          <ul>
            <li>
              <NavLink
                onClick={this.handleClickOutside}
                activeClassName="is-active"
                to="/logout"
              >
                <FontAwesomeIcon icon={['fas', 'sign-out-alt']} />
                {i18n.translate('general.logOut')}
              </NavLink>
            </li>
          </ul>
        </div>
        {diploma === true && (
          <Diploma
            trigger={diploma}
            appId={+appId}
            firstName={firstName}
            lastName={lastName}
            onClose={() => this.setState({ diploma: false })}
            appName={encodeURI(appName)}
            clientName={encodeURI(clientName)}
          />
        )}
        <div
          href={frame}
          data-fancybox="settings"
          data-type="iframe"
          className="settings"
        />
      </div>
    );
  }
}

export default onClickOutside(Dropdown);

Dropdown.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  handleClickOutside: PropTypes.func,
  unreadMessageCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  trainingComplete: PropTypes.bool,
};

Dropdown.defaultProps = {
  firstName: 'Firstname',
  lastName: 'Lastname',
  email: 'user@email.com',
  unreadMessageCount: '',
  handleClickOutside: () => {
    this.setState({
      menuToggle: false,
    });
  },
  trainingComplete: false,
};
